// extracted by mini-css-extract-plugin
export default {"dlDateFormatter":"src-js-common-components-formatters-DateFormatter---dlDateFormatter---E+Kla"};